export default "__VITE_ASSET__DK_qe2cY__"